import { useParams } from 'next/navigation';

export function useLocale(): { locale: string; localePrefix: string } {
  const params = useParams<{ locale: string }>();

  const locale = params?.locale ?? 'nl';
  const localePrefix = locale === 'nl' ? '' : `/${locale}`;

  return { locale, localePrefix };
}
